export const APP_FRONTEND_URL = "https://merchant.localramp.co";

export const handleSignUpClick = () => {
  window.open(`${APP_FRONTEND_URL}/auth/signup`, "_blank");
};
export const handleLoginClick = () => {
  window.open(`${APP_FRONTEND_URL}/auth/login`, "_blank");
};
